import PageHero from "@/components/PageHero";
import { COMPANY } from "@/data/company";

export default function Disclaimer() {
  return (
    <div>
      <PageHero
        eyebrow="Legal"
        title="Disclaimer"
        description="Important information about product data, images, brand ownership and limitation of liability."
      />
      <section className="section bg-white">
        <article className="container-nago prose prose-slate max-w-3xl">
          <h2>Brand ownership</h2>
          <p>
            All product names, brand names, logos and registered trademarks displayed on this
            website belong to their respective owners. Nago International is an authorized
            dealer, distributor, supplier or channel partner for the brands and products
            represented, and the use of these marks is solely for identification, informational
            and business-representation purposes.
          </p>

          <h2>Product information</h2>
          <p>
            Product descriptions, specifications, dimensions, packaging sizes and grades on this
            website are provided for general reference only and are subject to change by the
            respective manufacturers without prior notice. Please verify current specifications,
            availability and application suitability with our team before placing an order.
          </p>

          <h2>Product images</h2>
          <p>
            All product images are illustrative and used for identification purposes. Actual
            products, packaging, colour and appearance may vary depending on manufacturer
            updates and stock availability.
          </p>

          <h2>Limitation of liability</h2>
          <p>
            Nago International shall not be held liable for any loss, damage or business
            interruption arising from the use of information contained on this website without
            independent verification of product specifications, technical requirements or
            application suitability.
          </p>

          <h2>Contact</h2>
          <p>
            Nago International, {COMPANY.address}. Email:{" "}
            <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>. Phone:{" "}
            {COMPANY.phones.join(" · ")}.
          </p>
        </article>
      </section>
    </div>
  );
}
